import cn from "classnames";
import { FeatureRequestStatus, STATUS_META } from "./api";

const StatusChip: React.FC<{ status: FeatureRequestStatus; className?: string; size?: "xs" | "sm" }> = ({ status, className, size = "xs" }) => {
  const meta = STATUS_META[status];
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full font-medium whitespace-nowrap", size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5", meta.chip, className)} title={meta.hint}>
      <span className={cn("size-1.5 rounded-full", meta.dot)} />
      {meta.label}
    </span>
  );
};

export default StatusChip;
